export const composeArrayKeysToObject = (arr: string[], value) => {
    let object = arr.reduce((ac,a) => ({
        ...ac,
        [a]: value
    }), {});

    return object;
};

export const capitalizeFirst = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
}
